import { z } from 'zod';

/**
 * The points in a study's life the stores report to a `MilestoneListener` once the transaction
 * that reached them has committed: approvals, launch, abandonment, and a Brief published — which is also the study completing.
 *
 * They are study events rather than conversation events, and nothing in the running system acts
 * on them — a turn reads its own thread's bounded tail (`threadTailLength`) and never a summary.
 * The list stays because the stores still report them to whatever listener a caller passes.
 */
export const MILESTONE_KINDS = [
  'study_approved',
  'launched',
  'abandoned',
  'token_backstop',
  'brief_published',
] as const;
export const milestoneKindSchema = z.enum(MILESTONE_KINDS);
export type MilestoneKind = z.infer<typeof milestoneKindSchema>;
